import _ from 'lodash';
import isDataUrl from './is-data-url';

export const NAME_MAX_LENGTH = 25;

export default {
  form: 'profile',
  fields: ['_id', 'name', 'image', 'cover'],
  validate: values => {
    const errors = {};
    const { name, image, cover } = values;

    if (!_.trim(name)) {
      errors.name = 'required';
    } else if (name.length > NAME_MAX_LENGTH) {
      errors.name = 'too-long';
    }

    if (image && isDataUrl(image)) {
      errors.image = 'uploading';
    }
    if (cover && isDataUrl(cover)) {
      errors.cover = 'uploading';
    }

    return errors;
  },
};



// WEBPACK FOOTER //
// ./app/services/profile-form-settings.js